import { defineMessages } from 'react-intl';

export default defineMessages({
  regions: {
    id: 'filtersModal.regions',
    defaultMessage: '{count} {count, plural, one {region} other {regions}}',
  },
  allRegions: {
    id: 'filtersModal.allRegions',
    defaultMessage: 'All regions',
  },
});
